import { c as _c } from "react/compiler-runtime";
import { PaymentProcessorEnum, Tooltip, getPaymentProcessorTitle, toast } from '@systemeio/ui';
import { Integration } from 'modules/profile/payment-gateways/components/integration';
import { useConnectedPaymentIntegrations } from 'modules/profile/payment-gateways/hooks/use-connected-payment-integrations';
import { xenditDisconnect } from 'modules/profile/payment-gateways/integrations/xendit/api';
import XenditCreateModal from 'modules/profile/payment-gateways/integrations/xendit/components/xendit-create-modal';
import XenditEditModal from 'modules/profile/payment-gateways/integrations/xendit/components/xendit-edit-modal';
import { xenditPaymentProcessors } from 'modules/profile/payment-gateways/integrations/xendit/constants';
import { XenditPaymentIntegrationInterface } from 'modules/profile/payment-gateways/integrations/xendit/types';
import { getXenditHelpPageLink } from 'modules/profile/payment-gateways/integrations/xendit/utils';
import React, { FC, useState } from 'react';
import ConfirmationModal from 'shared/components/confirmation-modal';
import TransLoco from 'shared/components/trans-loco';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import useUser from 'shared/hooks/use-user';
import { BinIcon, XenditLogoIcon } from '@systemeio/ui/icons';
export const Xendit: FC = () => {
  const $ = _c(9);
  const {
    user
  } = useUser();
  const {
    t
  } = useLocoTranslation();
  const {
    getConnectedPaymentIntegration,
    removePaymentIntegration
  } = useConnectedPaymentIntegrations();
  const [deleteOpened, setDeleteOpened] = useState(false);
  let t0;
  if ($[0] !== deleteOpened || $[1] !== getConnectedPaymentIntegration || $[2] !== removePaymentIntegration || $[3] !== t || $[4] !== user?.dashboardLocale) {
    const xenditIntegration = getConnectedPaymentIntegration({
      matcher: _temp
    });
    const title = getPaymentProcessorTitle(xenditIntegration ? xenditIntegration.paymentProcessor : PaymentProcessorEnum.XenditPH);
    const onDelete = async () => {
      await xenditDisconnect();
      await removePaymentIntegration({
        matcher: _temp2
      });
      toast.success(t("dashboard.settings.payment-gateways.account_removed", {
        payment: title
      }));
    };
    let t1;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <XenditLogoIcon />;
      $[6] = t1;
    } else {
      t1 = $[6];
    }
    const t2 = user?.dashboardLocale;
    let t3;
    if ($[7] !== t2) {
      t3 = getXenditHelpPageLink(t2);
      $[7] = t2;
      $[8] = t3;
    } else {
      t3 = $[8];
    }
    t0 = <Integration logo={t1} additionalInfo={<a className="primary-link" href={t3} target="_blank" rel="noreferrer"><TransLoco t={t} i18nKey="dashboard.settings.payment_gateways.help_article_label" values={{
        integration: title
      }} /></a>}>{xenditIntegration ? <div className="flex w-full justify-between gap-3 overflow-hidden"><div className="flex flex-col gap-1 truncate">{!xenditIntegration.readyToUse && <p className="flex gap-1">{t("dashboard.settings.payment-gateways.integration_in_progress")}</p>}{xenditIntegration.details.organizationName && <p className="flex items-center gap-1 text-base lg:text-lg"><span>{`${t("dashboard.settings.payment-gateways.organization_name")}:`}</span><span className="text-text-primary truncate">{xenditIntegration.details.organizationName}</span></p>}<XenditEditModal details={xenditIntegration.details} /></div><Tooltip mode="hover" label={t("dashboard.settings.payment-gateways.remove_integration", {
          payment: title
        })} wrapperClassName="flex items-center" className="h-fit"><button className="group outline-hidden" onClick={() => setDeleteOpened(true)}><BinIcon className="group-focus-visible:fill-danger hover:fill-danger main-transition-colors h-[16px] w-[16px]" /></button></Tooltip><ConfirmationModal title={t("dashboard.settings.payment-gateways.remove_integration_description", {
          payment: title
        })} confirmationText={t("dashboard.settings.payment-gateways.remove_payment_text.xendit")} opened={deleteOpened} onClose={() => setDeleteOpened(false)} onConfirm={onDelete} /></div> : <XenditCreateModal />}</Integration>;
    $[0] = deleteOpened;
    $[1] = getConnectedPaymentIntegration;
    $[2] = removePaymentIntegration;
    $[3] = t;
    $[4] = user?.dashboardLocale;
    $[5] = t0;
  } else {
    t0 = $[5];
  }
  return t0;
};
function _temp(paymentProcessor) {
  return xenditPaymentProcessors.includes(paymentProcessor);
}
function _temp2(paymentProcessor_0) {
  return xenditPaymentProcessors.includes(paymentProcessor_0);
}